import PubSub from 'pubsub-js';
import { Splide } from '@splidejs/splide';

const $html = $('html');
const $target = $('.content__itemGroup.-main');
const $modalDom = '.modal-slide.-main';
const $modalParent = $($modalDom)
const $modalClose = $('.modal-close', $modalParent);
const $modalBackground = $('.modal-slideBackground', $modalParent);

let splide = null;

PubSub.subscribe('init', () => {
    splide = new Splide(`${$modalDom} .splide`, {
      type: 'loop',
      pauseOnHover: false,
      pauseOnFocus: false,
      pagination: false,
    }).mount();

    $modalClose.on('click', () => {
      $modalParent.removeClass('-show');
      $html.removeClass('-isModal');
    });
    
    $modalBackground.on('click', () => {
      $modalParent.removeClass('-show');
      $html.removeClass('-isModal');
    });

    $('.content__item', $target).each((index, element) => {
      $(element).on('click', () => {
        splide.go(index);
        $modalParent.addClass('-show');
        $html.addClass('-isModal');
      });
    });
});
